module.exports = __webpack_public_path__ + "static/img/logo.66bf7799.png";